import ElectronPlatformWindow from "~/operatorApplication/ts/platform/electron/ElectronPlatformWindow";
import AbstractPlatformWindow from "~/operatorApplication/ts/platform/AbstractPlatformWindow";
import {ElectronIPCRendererInstance} from "~/ts/library/electron/ipc/ElectronIPCRenderer";
import {
    OPERATOR_ELECTRON_CONSOLE_LOG,
    OPERATOR_ELECTRON_GET_APP_BRAND,
    OPERATOR_ELECTRON_GET_DEFAULT_DOWNLOAD_PATH,
    OPERATOR_ELECTRON_IPC_CHANGE_STATUS,
    OPERATOR_ELECTRON_IPC_CONFIG_RELOAD,
    OPERATOR_ELECTRON_IPC_DISPLAY_CHANGE,
    OPERATOR_ELECTRON_IPC_DOWNLOAD_BUTTON,
    OPERATOR_ELECTRON_IPC_EXIT_ACTION,
    OPERATOR_ELECTRON_IPC_FOCUS_CHANGE,
    OPERATOR_ELECTRON_IPC_GET_AVAILABLE_SPELLCHECK_LANGUAGES,
    OPERATOR_ELECTRON_IPC_GET_SYSTEM_IDLE_STATE,
    OPERATOR_ELECTRON_IPC_GET_SYSTEM_IDLE_TIME,
    OPERATOR_ELECTRON_IPC_IS_AUTO_START_ENABLED,
    OPERATOR_ELECTRON_IPC_LOGOUT,
    OPERATOR_ELECTRON_IPC_OPEN_APP_URL,
    OPERATOR_ELECTRON_IPC_RIGHT_CLICK,
    OPERATOR_ELECTRON_IPC_SELECT_MESSAGE_TEMPLATE_ACTION,
    OPERATOR_ELECTRON_IPC_SET_AUTO_START_ENABLED,
    OPERATOR_ELECTRON_IPC_SET_SPELLCHECK_LANGUAGES,
    OPERATOR_ELECTRON_SELECT_PATH,
    OperatorElectronIpcConfigReloadData
} from "~/operatorApplication/electron/src/ipc/ElectronIpcActionsConstant";
import ElectronPlatformNotification from "~/operatorApplication/ts/platform/electron/ElectronPlatformNotification";
import AbstractPlatformNotification from "~/operatorApplication/ts/platform/AbstractPlatformNotification";
import {
    MOUSEDOWN_EVENT_CUSTOM_DATA_KEY,
    MouseDownEventCustomDataInterface
} from "~/operatorApplication/ts/platform/ContextMenuHelper";
import {
    MAKE_OPERATOR_LOGOUT,
    OPERATOR_RELOAD_APP_CONFIG,
    OperatorApplicationEventManager,
    SET_OPERATOR_STATUS,
    SetOperatorStatusEventPayload
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {SHORTCUT_INSERT_MESSAGE_TEMPLATE} from "~/operatorApplication/ts/service/shortcuts/ShortcutsList";
import {__} from "~/ts/library/Translate";
import AbstractOperatorApplicationDesktopPlatform
    from "~/operatorApplication/ts/platform/AbstractOperatorApplicationDesktopPlatform";
import OperatorApplicationConfigInterface from "~/operatorApplication/ts/service/OperatorApplicationConfigInterface";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import StringHelper from "~/ts/library/StringHelper";
import {OperatorStatus} from "~/chat/ts/data/OperatorStatus";
import {SpellcheckLanguageInterface} from "~/operatorApplication/ts/platform/AbstractOperatorApplicationPlatform";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import {AbstractApiResult} from "~/core-ui/ts/request/AbstractApiResult";
import ElectronIpcDownloadInterface, {
    ElectronDownloadProgressInterface
} from "~/operatorApplication/electron/src/ipc/ElectronIpcDownloadInterface";
import {
    OperatorApplicationPlatformDownloadResultInterface
} from "~/operatorApplication/ts/platform/OperatorApplicationPlatformInterface";
import {ElNotification} from "element-plus";
import Random from "~/ts/library/Random";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";

const {getLangNameFromCode} = require('language-name-map')

//import setOperatorStatus from "~/operatorApplication/ts/service/status/SetOperatorStatus";

function isEditable(el: HTMLElement) {
    if (el) {
        if (el && ['input', 'textarea'].indexOf(el.tagName.toLowerCase()) > -1) {
            return !(el as HTMLInputElement).readOnly && !(el as HTMLInputElement).disabled;
        }
        //el = getSelection().anchorNode as HTMLElement; // selected node
        while (el) {
            if (el.isContentEditable) {
                return true;
            }
            el = el.parentElement;
        }
    }
    return false;
}

export default abstract class AbstractElectronOperatorApplicationPlatform extends AbstractOperatorApplicationDesktopPlatform {
    constructor() {
        super();
        this.handleAppUrl(window.location.href, true);
        document.addEventListener("mousedown", event => {
            if (event.button === 2) {
                let customData: MouseDownEventCustomDataInterface = (event as any)[MOUSEDOWN_EVENT_CUSTOM_DATA_KEY];
                if (!customData) {
                    customData = {};
                }
                customData.pasteAvailable = isEditable(event.target as any as HTMLElement);
                if (typeof customData.copyAvailable != "boolean") {
                    let selection = getSelection();
                    customData.copyAvailable = selection && selection.toString().length > 0;
                }
                customData.copyAvailable = true;
                ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_RIGHT_CLICK, customData);
            }
        });

        ElectronIPCRendererInstance.addMessageHandler(OPERATOR_ELECTRON_IPC_SELECT_MESSAGE_TEMPLATE_ACTION, (templateId: string) => {
            OperatorApplicationEventManager.emit(SHORTCUT_INSERT_MESSAGE_TEMPLATE, templateId);
        });


        ElectronIPCRendererInstance.addMessageHandler(OPERATOR_ELECTRON_IPC_CHANGE_STATUS, (statusId: OperatorStatus) => {
            //setOperatorStatus(statusId);
            let payload: SetOperatorStatusEventPayload = {
                statusId,
                rememberLastStatus: true
            };
            OperatorApplicationEventManager.emit(SET_OPERATOR_STATUS, payload);
        });

        ElectronIPCRendererInstance.addMessageHandler(OPERATOR_ELECTRON_IPC_LOGOUT, () => {
            //setOperatorStatus(statusId);
            OperatorApplicationEventManager.emit(MAKE_OPERATOR_LOGOUT);
        });

        ElectronIPCRendererInstance.addMessageHandler(OPERATOR_ELECTRON_CONSOLE_LOG, (value: string) => {
            console.log("electron console log", value);
        })

        ElectronIPCRendererInstance.addMessageHandler(OPERATOR_ELECTRON_IPC_OPEN_APP_URL, (url: string) => {
            this.handleAppUrl(url, true);
        });

        ElectronIPCRendererInstance.addMessageHandler(OPERATOR_ELECTRON_IPC_DISPLAY_CHANGE, () => {
            this.notifications.reposition();
        });

        ElectronIPCRendererInstance.addMessageHandler(OPERATOR_ELECTRON_IPC_FOCUS_CHANGE, (isFocused: boolean) => {
            this.window.setIsFocused(isFocused);
        });

        let reloadConfig = (config: OperatorApplicationConfigInterface) => {
            let p: OperatorElectronIpcConfigReloadData = {
                translate: {
                    copy: __("Копировать выделенный текст"),
                    copyLink: __("Скопировать ссылку"),
                    paste: __("Вставить"),
                    addToDictionary: __("Добавить в словарь"),
                    quit: __("Закрыть"),
                    away: StringHelper.capitalize(__("отошёл")),
                    invisible: StringHelper.capitalize(__("невидимый")),
                    openWindow: __("Открыть"),
                    logout: StringHelper.capitalize(__("выход")),
                    online: StringHelper.capitalize(__("в сети"))
                },
                minimizeToTray: config.minimizeToTray,
                isAuthorized: OperatorAccountStore.isAuthorized.value,
                login: OperatorAccountStore.login.value,
                currentStatusId: OperatorAccountStore.status.value.id,
                darkThemeEnabled: config.darkThemeEnabled
            };
            ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_CONFIG_RELOAD, p)
        };

        OperatorApplicationEventManager.addEventListener(OPERATOR_RELOAD_APP_CONFIG, reloadConfig);
    }

    protected createWindowInstance(): AbstractPlatformWindow {
        return new ElectronPlatformWindow();
    }

    protected createNotificationInstance(): AbstractPlatformNotification {
        return new ElectronPlatformNotification();
    }

    get isNative(): boolean {
        return true;
    }

    get platformDescr(): string {
        let platform: string = process.platform;
        let release = process.getSystemVersion();
        if (platform == "win32") {
            platform = "Windows";
        } else if (platform == "darwin") {
            platform = "macOS";
        }
        return `${platform} ${release}, ${process.arch}`;
    }


    async getBrandId(): Promise<string> {
        return await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_GET_APP_BRAND);
    }

    async getDefaultDownloadPath(): Promise<string> {
        return await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_GET_DEFAULT_DOWNLOAD_PATH);
    }

    async selectDirectory(defaultPath?: string): Promise<string> {
        return await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_SELECT_PATH, defaultPath);
    }

    protected closeApplication() {
        return ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_EXIT_ACTION);
    }

    openExternal(url: string) {
        (async () => {
            try {
                let protocol = new URL(url).protocol;
                if (protocol == "file:") {
                    return AbstractApiResult.showError("Открытие ссылок с протоколом file:// запрещено из соображений безопасности");
                } else if (!['https:', 'http:', 'mailto:', 'onlinechat:'].includes(protocol)) {
                    try {
                        await ElConfirm(`Вы уверены, что хотите открыть ссылку ${url} по протоколу ${protocol}? Это может быть небезопасно.\n\nДелайте это только в случае, если вы уверены в безопасности этой ссылки.`);
                    } catch (e) {
                        return;
                    }
                }

                require("electron").shell.openExternal(url);
            } catch (e) {

            }
        })();


    }

    get isAutoStartAvailable(): boolean {
        return true;
    }

    get isSystemIdleStateAvailable(): boolean {
        return true;
    }

    isAutoStartEnabled(): Promise<boolean> {
        return ElectronIPCRendererInstance.invoke<boolean>(OPERATOR_ELECTRON_IPC_IS_AUTO_START_ENABLED);
    }

    setAutoStartEnabled(value: boolean): Promise<void> {
        return ElectronIPCRendererInstance.invoke<void>(OPERATOR_ELECTRON_IPC_SET_AUTO_START_ENABLED, value);
    }

    getSystemIdleState(idleThreshold: number): Promise<"active" | "idle" | "locked" | "unknown"> {
        return ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_GET_SYSTEM_IDLE_STATE, idleThreshold);
    }

    getSystemIdleTime(): Promise<number> {
        return ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_GET_SYSTEM_IDLE_TIME);
    }

    get isWindows(): boolean {
        return process.platform == "win32";
    }

    get isLinux(): boolean {
        return process.platform == "linux";
    }

    get isMac(): boolean {
        return process.platform == "darwin";
    }

    async getSpellcheckAvailableLanguages(): Promise<SpellcheckLanguageInterface[]> {
        let result = await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_GET_AVAILABLE_SPELLCHECK_LANGUAGES) as string[];
        return result.map(code => {
            let descr = code;
            let id = code.split('-')[0].toLowerCase();
            let langName = getLangNameFromCode(id);
            if (langName) {
                descr = langName.name;
                if (langName.name != langName.native) {
                    descr += ` / ${langName.native}`;
                }
                descr += ` / ${code}`;
            }
            return {
                id: code,
                descr
            }
        });
    }

    setSpellcheckLanguages(langCodes: string[]) {
        ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_SET_SPELLCHECK_LANGUAGES, langCodes);
    }

    public isPlatformCanDownload(): boolean {
        return true;
    }

    private getProgressString(progress: ElectronDownloadProgressInterface) {
        return __("%1$s из %2$s", progress.currentFile, progress.files) + ` (${Math.ceil(progress.currentFilePercent * 100)}%)`;
    }

    async download(url: string[]) {
        let notification = ElNotification({
            showClose: true,
            title: __(`Скачивание файлов`),
            message: this.getProgressString({
                currentFilePercent: 0,
                files: url.length,
                currentFile: 1,
                currentFileProgress: 0,
                currentFileSize: 0
            }),
            //iconClass: $iconLight('download'),
            duration: 0
        });
        //TODO: а что вместо iconClass?
        let id = Random.uid();
        let params: ElectronIpcDownloadInterface = {
            url,
            id,
            directory: OperatorApplicationConfigInstance.downloadPath
        };
        /*
        //TODO: тоже непонятно пока
        let el: HTMLElement = notification?.$el.querySelector(".el-notification__content");
        ElectronIPCRendererInstance.addMessageHandler(id, (payload: ElectronDownloadProgressInterface) => {
            if (el) {
                el.innerText = this.getProgressString(payload);
            }
        });
        */

        try {
            let result: OperatorApplicationPlatformDownloadResultInterface = await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_DOWNLOAD_BUTTON, params);
            notification?.close();
            //notification.close();
            ElNotification({
                showClose: true,
                title: __(`Успешно: %1$s, ошибок: %2$s`, result.success, result.error),
                message: __('Скачивание завершено'),
                //iconClass: $iconLight(result.error ? 'ban' : 'check'),
                //TODO: а что вместо iconClass?
                duration: 2000
            });
        } catch (e) {

        }
        ElectronIPCRendererInstance.removeAllMessageHandlers(id);


    }
}